/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP10_ANSWERS = [
    'Stephanie sees the kids playing a game. She asks them, “Do you guys remember what tomorrow is?”',
    'Tony seems excited for swimming! Harry is excited because it is cleaning day!',
    'The next morning, everyone starts cleaning. Matt reminds Holly and Harry, “Do a good job or no swimming.”',
    'While cleaning, Harry sees dark clouds in the sky. Holly says, “It looks like a storm is coming.”',
    'Suddenly, there’s a loud thunder and Tony breaks a blue vase.',
    'Then, the thunder booms again and Matt falls over.',
    'After seeing that everyone is okay, Stephanie says, “Let’s go, everyone. Back to cleaning.”',
    'Later, the sun comes out, and Holly sees a rainbow!',
    'The rainbow disappears, but Harry says to Matt, “Come see the bright colors of the rainbow, Dad!”',
    'While Matt is looking for the rainbow, the kids quietly leave the room. Tony says, “Just keep looking! Don’t look at us.”',
    'Finally, Matt turns around and says, “Where is everybody? Wait for me!”',
];

// export const HHT2_EP10_ANSWER_SOUNDS = [
//     '/HHT2_AB EP10_dyr01.mp3',
//     '/HHT2_AB EP10_dyr02.mp3',
//     '/HHT2_AB EP10_dyr03.mp3',
//     '/HHT2_AB EP10_dyr04.mp3',
//     '/HHT2_AB EP10_dyr05.mp3',
//     '/HHT2_AB EP10_dyr06.mp3',
//     '/HHT2_AB EP10_dyr07.mp3',
//     '/HHT2_AB EP10_dyr08.mp3',
//     '/HHT2_AB EP10_dyr09.mp3',
//     '/HHT2_AB EP10_dyr10.mp3',
//     '/HHT2_AB EP10_dyr11.mp3',
// ];

export const HHT2_EP10_ANSWER_SOUNDS = [
    '/4848fd6bd98bf6c2761a9f54332afe84.mp3',
    '/e1252331b9d30574cddb9b6a27a9f329.mp3',
    '/12db424d5b17706a05b324cc1ddaf05a.mp3',
    '/81f80a09980dd0fcc01b2aa00b5a1d32.mp3',
    '/ccb33267bcd863d4481530b49e793d80.mp3',
    '/5db516bf87acc680ac178be5624ac9b8.mp3',
    '/b1ca90c47582b091439679ce81beb84a.mp3',
    '/de21cc2ae2476fcd8d11525968964563.mp3',
    '/5093f1d39be6e2593d4d5a67829c6ceb.mp3',
    '/55ff543dd5888a656fb67508935ed091.mp3',
    '/88e8c04cf35190db27123e3a9a90cca6.mp3',
];

export const HHT2_EP10_QUIZ_ITEMS = [{
    'A': HHT2_EP10_ANSWERS[1],
    'B': HHT2_EP10_ANSWERS[10],
    'SoundIndexA': 1,
    'SoundIndexB': 10,
    'answer': HHT2_EP10_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP10_ANSWERS[4],
        'B': HHT2_EP10_ANSWERS[0],
        'SoundIndexA': 4,
        'SoundIndexB': 0,
        'answer': HHT2_EP10_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP10_ANSWERS[2],
        'B': HHT2_EP10_ANSWERS[7],
        'SoundIndexA': 2,
        'SoundIndexB': 7,
        'answer': HHT2_EP10_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP10_ANSWERS[9],
        'B': HHT2_EP10_ANSWERS[3],
        'SoundIndexA': 9,
        'SoundIndexB': 3,
        'answer': HHT2_EP10_ANSWERS[9],
        'sound': [10],
        'exception': false,
    },
]
